import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × CLAUDIE PIERLOT: Elegance meets pattern logic
// Dot matrices, polka-grid hybrid, ribbon lines
export function VasarelyClaudieMode({ brand }: ModeRendererProps) {
  return (
    <g>
      <defs>
        <linearGradient id="claudie-gentle" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#FFF5F5" />
          <stop offset="50%" stopColor="#FFE8E8" />
          <stop offset="100%" stopColor="#FFD5D5" />
        </linearGradient>
        <pattern id="claudie-polka" x="0" y="0" width="30" height="30" patternUnits="userSpaceOnUse">
          <circle cx="15" cy="15" r="4" fill="#E8B4B8" opacity="0.3" />
        </pattern>
      </defs>

      {/* Delicate pastel background */}
      <rect x="0" y="0" width="794" height="1123" fill="url(#claudie-gentle)" />

      <g transform="translate(397 540)">
        {/* Polka-grid hybrid overlay */}
        <rect x="-397" y="-540" width="794" height="1123" fill="url(#claudie-polka)" />

        {/* Dot matrices */}
        {Array.from({ length: 20 }).map((_, i) =>
          Array.from({ length: 28 }).map((_, j) => {
            const x = (i - 9.5) * 38;
            const y = (j - 13.5) * 38;
            const size = 2 + Math.sin((i + j) * 0.5) * 1.5;
            
            return (
              <circle
                key={`${i}-${j}`}
                cx={x}
                cy={y}
                r={size}
                fill="#D4949C"
                opacity="0.4"
              />
            );
          })
        )}

        {/* Ribbon lines */}
        {Array.from({ length: 12 }).map((_, i) => {
          const y = -300 + i * 50;
          return (
            <path
              key={i}
              d={`M ${-350} ${y} Q ${-100} ${y + 20} ${0} ${y} Q ${100} ${y - 20} ${350} ${y}`}
              fill="none"
              stroke="#E8B4B8"
              strokeWidth="2"
              opacity="0.3"
            />
          );
        })}

        {/* Parisian gentleness circles */}
        {Array.from({ length: 10 }).map((_, i) => {
          const r = 50 + i * 28;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke="#E8B4B8"
              strokeWidth="1"
              opacity={0.3 - i * 0.025}
              strokeDasharray="5 5"
            />
          );
        })}

        {/* Pattern logic grid */}
        {Array.from({ length: 12 }).map((_, i) =>
          Array.from({ length: 16 }).map((_, j) => {
            const x = (i - 5.5) * 55;
            const y = (j - 7.5) * 60;
            
            return (
              <rect
                key={`${i}-${j}`}
                x={x - 25}
                y={y - 28}
                width="50"
                height="56"
                fill="none"
                stroke="#F0C4C8"
                strokeWidth="1"
                opacity="0.2"
              />
            );
          })
        )}

        {/* Central delicate flower */}
        {[0, 45, 90, 135, 180, 225, 270, 315].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          const r = 50;
          
          return (
            <g key={angle}>
              <circle
                cx={Math.cos(rad) * r}
                cy={Math.sin(rad) * r}
                r="25"
                fill="#E8B4B8"
                opacity="0.3"
              />
              <circle
                cx={Math.cos(rad) * r}
                cy={Math.sin(rad) * r}
                r="20"
                fill="none"
                stroke="#D4949C"
                strokeWidth="1"
                opacity="0.5"
              />
            </g>
          );
        })}
        <circle cx="0" cy="0" r="30" fill="#D4949C" opacity="0.5" />
        <circle cx="0" cy="0" r="20" fill="#FFF5F5" opacity="0.8" />
        <circle cx="0" cy="0" r="10" fill="#E8B4B8" opacity="0.7" />
      </g>

      {/* Delicate ethics */}
      <text x="397" y="1010" textAnchor="middle" fontFamily="sans-serif" fontSize="10" fill="#D4949C" fontStyle="italic">
        élégance délicate
      </text>
    </g>
  );
}
